import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { handleAuthProblem, isProblem } from "./lib/api";
import { createAppRouter } from "./routes";
import "./styles.css";

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: (e) => void handleAuthProblem(e) }),
  mutationCache: new MutationCache({ onError: (e) => void handleAuthProblem(e) }),
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (count, e) => !(isProblem(e) && e.status < 500) && count < 2,
    },
  },
});

const router = createAppRouter(queryClient);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
